<!--
 * @description: 维修--确认完成
 * @param: 
 * @return: 
-->
<template>
  <div class="user-management-container">
    <tabel-panel
      ref="tabel"
      :rowTemplate="rowTemplate"
      api="ConfirmCompletion"
      :condition="conditionData"
      editType="pop"
      :autoSearch="true"
      :showCancelButton="false"
      @popConfirmButtonClick="popConfirmButtonClick"
      @checkColumnChange="checkColumnChange"
      :clickRowSelected="false"
      :popToCustomer="true"
    >
      <template v-slot:tabelTitleRight>
				<!-- <add-button @buttonClick="arrReturn">
					批量返回
				</add-button> -->
				<add-button @buttonClick="CommitsBtn">
					完成
				</add-button>
			</template>

      <template v-slot:tabelTitleLeft>
        <div>确认完成</div>
      </template>

      <template v-slot:condition style="height: 200px;">
        <text-field
          v-model:value="conditionData.compid"
          labelText="客户名称:"
          :clearable="true"
          type="select"
          :selectRemoteSearchData="selectOuguName"
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.SN"
          labelText="SN号:"
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.model"
          labelText="型号:"
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.courierNumber"
          labelText="快递单号:"
          class="condition-container-input"
        >
        </text-field>

      </template>
      <template v-slot:repairBtn="$opData">
        <div class="opration">
          <div class="style-aaa" @click="customerRowDblClick($opData.data.row)">完成</div>
          <!-- <control-button
            class="item"
            @buttonClick="customerRowDblClick($opData.data.row)"
            >完成</control-button
          > -->
        </div>
      </template>
    </tabel-panel>
  </div>
</template>

<script>
import textField from "@/components/textField.vue";
import delButton from "@/components/delButton.vue";
import addButton from "@/components/addButton.vue";
import controlButton from "@/components/controlButton.vue";
import updateButton from "@/components/updateButton.vue";
import tabelPanel from "@/components/tabelPanel.vue";
import popDialog from "@/components/popDialog.vue";
import tableApi from "@/api/tabel.js";
import {
  symptomEdit,
  RepairProductCancel,
  ChangeRepairDetailStateByIds,
} from "@/api/index.js";
import { errMsg, successMsg } from "@/notify/index.js";

export default {
  name: "RepairConfirm",
  components: {
    textField,
    addButton,
    delButton,
    tabelPanel,
    popDialog,
    updateButton,
    controlButton,
  },
  data() {
    return {
      rowData: null,
      rowTemplate: [
        {
          columnType: "check",
          width: "80",
        },
        {
          headerLabel: "客户名称",
          width: 180,
          sortable: true,
          dataIndex: "CompName",
        },
        {
          headerLabel: "客户姓名",
          sortable: true,
          width: 100,
          dataIndex: "LinkMan",
        },
        {
          headerLabel: "客户电话",
          sortable: true,
          width: 100,
          dataIndex: "TelNo",
        },
        {
          headerLabel: "手机",
          sortable: true,
          dataIndex: "Phone",
        },
        {
          headerLabel: "客户地址",

          dataIndex: "Address",
        },
        {
          headerLabel: "型号",
          width: 80,
          sortable: true,
          dataIndex: "ModelNoName",
        },
        {
          headerLabel: "SN", //0
          width: 160,
          sortable: true,
          dataIndex: "SerialNoName",
          dataRender: (v, { $index, column, row }) => {
            return (
              '<span style="color:' +
              (row.Distinguish == 1 ? "red" : "") +
              '">' +
              v +
              ""
            );
          },
        },
        {
          headerLabel: "寄出日期",
          width: 120,
          sortable: true,
          dataIndex: "ReciveDate",
        },
        {
          headerLabel: "快递信息",
          width: 180,
          sortable: true,
          dataIndex: "TransferInfo",
        },
        {
          headerLabel: "维修中心",
          width: 80,
          dataIndex: "ServerName",
        },
        {
          headerLabel: "维修状态",
          width: 100,
          sortable: true,
          dataIndex: "State",
        },
        {
          headerLabel: "递送方式",
          sortable: true,
          width: 100,
          dataIndex: "NotExpressName",
        },
        
        {
          headerLabel: "备注",
          dataIndex: "Appendix",
        },
        {
          headerLabel: "维修工程师",
          width: 100,
          dataIndex: "RepairMan",
        },
        {
          headerLabel: "附件",

          dataIndex: "AttachName",
        },
        {
          headerLabel: "确认完成",
          slot: "repairBtn",
          fixed: "right",
        },
      ],
      conditionData: {
        SN: "",
        courierNumber: "",
        model: ""
      },
    };
  },
  methods: {
    async selectOuguName() {
      let source = await tableApi.CompanyInfo();
      if (source.code == 0) {
        let data = source.data.list.map(({ Company_Id, CompName }) => {
          return {
            label: CompName,
            value: Company_Id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    // checkColumnChange({ checked, index }){
    //   console.log("checkColumnChange", checked, index)
      // checkSelectedAll
    // },
    reloadData() {
      this.$refs.tabel.reloadData();
    },

    /*  delSingleUser({ row }) {
      let id = row.Id;
      RepairProductCancel({ id }).then((data) => {
        if (data.code == 0) {
          successMsg(data.message);
          this.reloadData();
        } else {
          errMsg(data.message);
        }
      });
    }, */
    //弹层事件
    popConfirmButtonClick({ slotData }) {
      console.log(slotData);
    },
    // 点击完成按钮，row 为点击的某一行数据
    customerRowDblClick(row) {
      console.log("row:", row);
      this.rowData = row;
      console.log("row:", this.rowData);
      // const { Id, State_Id, IllDesc } = row;
      ChangeRepairDetailStateByIds([row.Id]).then((data) => {
        if (data.code == 0) {
          successMsg(data.message);
          this.reloadData();
        } else {
          errMsg(data.message);
        }
      });
    },
    //   批量确认完成
    CommitsBtn(){
      let sels = this.$refs.tabel.getSelection().map( i => i.Id)
      if (sels.length < 1) {
        return errMsg("请选择数据");
      }
       ChangeRepairDetailStateByIds(sels).then((data) => {
        if (data.code == 0) {
          successMsg(data.message);
          this.reloadData();
        } else {
          errMsg(data.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~@/assets/styles/_handle.scss";

#suerSwitch .el-switch__core {
  width: 26px;
}

.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: red;
}

.user-management-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  align-items: center;
  align-content: center;
  @include background_color("user-management-bg-color");

  .del {
    margin-left: 10px;
  }

  .condition-container-input {
    width: 270px;
  }

  .opration {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;

    .item {
      &:nth-child(n + 1) {
        margin-left: 10px;
      }
    }
  }
  .menuPowerBtn {
    // color:rgb(255, 255, 255)!important;
    // background:rgb(100,134,232)!important;
  }
  .menuPowerBOX {
    .el-button--default {
      width: 90px;
      height: 30px;
      color: #ffffff;
      background: rgb(100, 134, 232);
      border-radius: 4px;
    }
    .item {
      height: 30px;
      color: #ffffff !important;
      padding: 10px 15px !important;
      background: rgb(100, 134, 232) !important;
    }
  }
  #loadBOX {
    width: 100%;
    height: 100%;
  }
  .pop-dialog-conver {
    background: yellow;
  }
  .pop-dialog-container {
  }
  .oprationTree {
    background-color: #ecf5ff;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    padding: 25px 20px 15px 20px;

    .detailed-box {
      width: 100%;
      height: 100%;
      position: relative;
      border: 1px solid #99bce8;
      background-color: #f4f7f6;
      border-radius: 10px;

      .detailed-title {
        font-family: Microsoft YaHei;
        font-weight: normal;
        padding: 10px;
      }

      .text-field-container {
        background: #f4f7f6 !important;
        margin: 10px 20px;
        width: 320px;
      }
      .user-management-container .condition-container-input {
        margin: 5px 10px;
      }

      .pop-dialogClose {
        position: absolute;
        top: 20px;
        right: 15px;

        .el-icon-close:before {
          font-size: 28px;
        }
        .el-icon-close:hover {
          color: #f92323;
        }
      }
    }
  }
  .pop-dialog-conver {
    display: block !important;
    width: 100% !important;
    height: 100% !important;
  }
}
::v-deep .el-table__body-wrapper {
  overflow: auto !important;
}
.style-aaa{
	cursor:pointer;
	color:rgb(100,134,232);
	// style="{cursor:'pointer',color:'rgb(100,134,232)'}"
}
</style>
